/**
 * Demo pricing — fixed local-currency amounts for the $2 demo.
 *
 * These are rounded "nice numbers" per market, NOT live FX conversions.
 * They must stay in sync with the amounts charged by the backend
 * (SecureCheckout.js COUNTRY_CURRENCY_MAP) so the price shown on
 * the landing page button matches what the user pays at checkout.
 */

// Country name → { currency, amount, symbol }
const DEMO_PRICES = {
  Uganda:          { currency: 'UGX', amount: 7600,   symbol: 'USh' },
  Kenya:           { currency: 'KES', amount: 260,    symbol: 'KSh' },
  Nigeria:         { currency: 'NGN', amount: 3000,   symbol: '₦' },
  Ghana:           { currency: 'GHS', amount: 24,     symbol: 'GH₵' },
  Tanzania:        { currency: 'TZS', amount: 5000,   symbol: 'TSh' },
  Rwanda:          { currency: 'RWF', amount: 2600,   symbol: 'RF' },
  'South Africa':  { currency: 'ZAR', amount: 38,     symbol: 'R' },
  'United Kingdom':{ currency: 'GBP', amount: 1.60,   symbol: '£' },
  'United States': { currency: 'USD', amount: 2,      symbol: '$' },
};

const DEFAULT_PRICE = { currency: 'USD', amount: 2, symbol: '$' };

/**
 * Get the formatted demo price for a given country name.
 * Returns a string like "USh 3,800" or "$1".
 */
export function formatDemoPrice(countryName) {
  const p = DEMO_PRICES[countryName] || DEFAULT_PRICE;
  const formatted = p.amount >= 100
    ? p.amount.toLocaleString()
    : (p.amount % 1 === 0 ? p.amount.toString() : p.amount.toFixed(2));
  return `${p.symbol} ${formatted}`;
}

export { DEMO_PRICES };
